import jwtAuthAxios from "./auth/jwtAuth";

const phoneNumberServices = {};

// Valida un teléfono con Twilio y lo devuelve como se va a guardar (+56912345678). Sin alertas: si falla, el campo
// sigue con la revisión de formato local y el backend vuelve a validar al guardar.
phoneNumberServices.lookup = async (phone) => {
    const { data } = await jwtAuthAxios.post("/phone_numbers/lookup", { phone }, { silentErrors: true });
    return data;
};

export default phoneNumberServices;
